module.exports = __webpack_public_path__ + "img/Meet the team Icon - charcoal.529140b1.svg";